import React from "react"
import PropTypes from "prop-types"

import ButtonFixedVoice from "../../ButtonFixedVoice"
import CardInfo from "../../Inputs/CardInfo"
import Typograph from "../../../../../components/Typograph"

import styles from "./styles.css"

import { TEXT_ACTION_SUCCESS } from "../../../constants"

const SuccessEdit = ({ action, onCloseSuccess }) => {
  return (
    <div>
      <Typograph htmlTag="h1" size="medium" color="outer_space" weight="bold">
        {TEXT_ACTION_SUCCESS[action]}
      </Typograph>

      <div className={styles.portability_success}>
        <Typograph
          htmlTag="p"
          size="medium"
          color="outer_space"
          weight="medium"
        >
          Você poderá remover a suspensão quando quiser.
        </Typograph>
      </div>

      <CardInfo>
        Conforme as regras de portabilidade, a suspensão é válida por 30 dias.
        Após este período a portabilidade será cancelada automaticamente.
      </CardInfo>
      <div className={styles.button_full}>
        <ButtonFixedVoice name="Fechar" onAction={() => onCloseSuccess()} />
      </div>
    </div>
  )
}

SuccessEdit.propTypes = {
  action: PropTypes.string,
  onCloseSuccess: PropTypes.func
}

export default SuccessEdit



// WEBPACK FOOTER //
// ./src/scenes/FixedVoice/components/ActionForm/SuccessEdit/index.js